import { render } from "./WalletCard.vue?vue&type=template&id=41c58794"
import script from "./WalletCard.vue?vue&type=script&lang=js"
export * from "./WalletCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__